<div class="sheet-handle"></div>

<div class="sheet-header">
  <div class="sheet-header-text">
    <h2 class="sheet-title">Libro Scout</h2>
    <p class="sheet-subtitle">
      {{ data.userName || "Jugador" }} · {{ data.badges.length || 0 }} insignias
    </p>
  </div>
  <button class="sheet-close" (click)="sheetRef.dismiss()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="sheet-filters">
  <button
    type="button"
    class="filter-chip"
    [class.active]="filter === 'all'"
    (click)="setFilter('all')"
  >
    Todas
  </button>
  <button
    type="button"
    class="filter-chip"
    [class.active]="filter === 'unlocked'"
    (click)="setFilter('unlocked')"
  >
    Desbloqueadas
  </button>
  <button
    type="button"
    class="filter-chip"
    [class.active]="filter === 'locked'"
    (click)="setFilter('locked')"
  >
    Bloqueadas
  </button>
  <button
    type="button"
    class="filter-chip"
    [class.active]="filter === 'bronze'"
    (click)="setFilter('bronze')"
  >
    Bronce
  </button>
  <button
    type="button"
    class="filter-chip"
    [class.active]="filter === 'silver'"
    (click)="setFilter('silver')"
  >
    Plata
  </button>
  <button
    type="button"
    class="filter-chip"
    [class.active]="filter === 'gold'"
    (click)="setFilter('gold')"
  >
    Oro
  </button>
</div>

<div class="sheet-list">
  @if (filteredBadges.length === 0) {
    <div class="badge-empty-state empty-placeholder">
      <img src="/assets/imgs/empty.svg" alt="No hay insignias para mostrar" />
      <p class="empty-title">{{ emptyStateTitle }}</p>
      <p class="empty-sub">{{ emptyStateSubtitle }}</p>
    </div>
  } @else {
    @for (badge of filteredBadges; track badge.id) {
      <div class="badge-row" [class.badge-row--locked]="!badge.unlocked">
        <span class="badge-icon">{{ badge.icon }}</span>
        <div class="badge-copy">
          <span class="badge-title">{{ badge.title }}</span>
          <span class="badge-desc">{{ badge.description }}</span>
          @if (!badge.unlocked && badge.progress) {
            <div class="book-progress">
              <i [style.width.%]="badge.progress.percentage"></i>
            </div>
            <small>{{ badge.progress.label }}</small>
          }
        </div>
        <span
          class="badge-tier"
          [class.tier--gold]="badge.tier === 'gold'"
          [class.tier--silver]="badge.tier === 'silver'"
          [class.tier--bronze]="badge.tier === 'bronze'"
        >{{ badge.tier | uppercase }}</span>
      </div>
    }
  }
</div>
